/* tslint:disable */
/* eslint-disable */
/**
 * Easy Invoices API v1
 * The Easy Invoices API for Shopify embedded app - automatic invoice generation and export functionality
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * The merchant\'s settings lock, derived from the NEWEST invite exactly as the merchant\'s own settings page derives it.
 * @export
 * @enum {string}
 */

export enum OpsDatevLockState {
    None = 'NONE',
    AwaitingDelivery = 'AWAITING_DELIVERY',
    Pending = 'PENDING',
    Finalized = 'FINALIZED',
    Expired = 'EXPIRED',
    Withdrawn = 'WITHDRAWN',
    Superseded = 'SUPERSEDED'
}



